var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "actions-collapsed-list" },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-function exit-collapsed-list",
          on: { click: _vm.collapseActions }
        },
        [
          _c("i", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.right.hover",
                value: _vm.$t("CANCEL"),
                expression: "$t('CANCEL')",
                modifiers: { right: true, hover: true }
              }
            ],
            staticClass: "glyphicon glyphicon-chevron-left",
            attrs: { "aria-hidden": "true" }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "action-icon" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-list-function",
            attrs: { "data-testid": "edit-integration-button" },
            on: { click: _vm.showForm }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.right.hover",
                  value: _vm.$t("EDIT"),
                  expression: "$t('EDIT')",
                  modifiers: { right: true, hover: true }
                }
              ],
              staticClass: "typcn typcn-edit",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "EDIT",
                  expression: "'EDIT'"
                }
              ],
              staticClass: "hint-text-mobile"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showRefreshButton
        ? _c("div", { staticClass: "action-icon" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-list-function",
                attrs: { disabled: _vm.isRefreshDisabled },
                on: { click: _vm.refreshToken }
              },
              [
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.right.hover",
                      value: _vm.$t("REFRESH_TOKEN"),
                      expression: "$t('REFRESH_TOKEN')",
                      modifiers: { right: true, hover: true }
                    }
                  ],
                  staticClass: "typcn typcn-arrow-sync",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "REFRESH_TOKEN",
                      expression: "'REFRESH_TOKEN'"
                    }
                  ],
                  staticClass: "hint-text-mobile"
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "action-icon" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-list-function",
            attrs: {
              disabled: _vm.disabled,
              "aria-label": _vm.enabledButtonLabel
            },
            on: { click: _vm.toggleEnabled }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.right.hover",
                  value: _vm.enabledButtonLabel,
                  expression: "enabledButtonLabel",
                  modifiers: { right: true, hover: true }
                }
              ],
              class: _vm.enabledIconClass,
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "hint-text-mobile" }, [
              _vm._v(_vm._s(_vm.enabledButtonLabel))
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-icon" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-list-function",
            attrs: { "data-testid": "delete-icon", disabled: _vm.disabled },
            on: { click: _vm.deleteIntegration }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.right.hover",
                  value: _vm.$t("DELETE"),
                  expression: "$t('DELETE')",
                  modifiers: { right: true, hover: true }
                }
              ],
              staticClass: "typcn typcn-trash",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "DELETE",
                  expression: "'DELETE'"
                }
              ],
              staticClass: "hint-text-mobile"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("ChangeLogObjectButtonAction", {
        attrs: {
          "is-disabled": _vm.disabled,
          "object-id": _vm.integration.id,
          "object-name": _vm.integration.name,
          "object-type": "integration"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }